import { code } from "@spscommerce/utils";

export const SpsIncrementorExamples = {
    basic: {
        label: "Incrementor",
        description: "info about incrementor",
        examples: {
            basic: {
                template: code`
                    <sps-incrementor min="10" max="50" step="5"
                        id="basicIncrementor"
                        aria-label="Count"
                        [(ngModel)]="count">
                    </sps-incrementor>
                `,
                class: code`
                    class DemoComponent {
                        count = 20;
                    }
                `
            },
        }
    },
};
